import { ReactKit } from '@team/react';
import { Entry as Root } from './entry';
import { Slides } from './components/slides';
import { CompactPagination } from './components/compact-pagination';

export const Carousel = ReactKit.createCompoundComponent(Root, {
  Slides,
  CompactPagination,
});

Root.displayName = 'Carousel';
Slides.displayName = 'CarouselSlides';
CompactPagination.displayName = 'CarouselCompactPagination';

export { useContextForExternal as useCarouselContext } from './services/context';
